import { useContext, useState } from 'react'

import OutsideClickHandler from 'react-outside-click-handler'

import { SideBarBlockItem } from '@components/UI/SideBar'
import { InformationTooltipContext } from '@context/InformationTooltip'
import { IMember } from '@store/members'
import { Container } from '@tribegroup'
import { pxToRem } from '@utils'
import InboxMemberPopupMenu from './PopupMenu'
import InboxMemberRemoveConfirmation from './RemoveConfirmation'

interface IProps {
  member: IMember
  campaignId: number
}

const InboxMember: React.FC<IProps> = ({ member, campaignId }) => {
  const { showTooltip, hideTooltip } = useContext(InformationTooltipContext)

  const [isRemoveConfirmationOpen, setIsRemoveConfirmationOpen] = useState(false)
  const [isActive, setIsActive] = useState(false)

  const showRemoveConfirmation = () => {
    setIsRemoveConfirmationOpen(true)
    onHideTooltip()
  }

  const hideRemoveConfirmation = () => {
    setIsRemoveConfirmationOpen(false)
  }

  const toggleActive = (event: React.MouseEvent<HTMLDivElement>) => {
    setIsActive(!isActive)
    if (!isActive) {
      showPopup(event)
    }
  }

  const onHideTooltip = () => {
    hideTooltip()
    setIsActive(false)
  }

  const showPopup = (event: React.MouseEvent<HTMLDivElement>) => {
    const target = event.currentTarget as HTMLElement
    const { left, top } = target.getBoundingClientRect()

    showTooltip(
      <OutsideClickHandler onOutsideClick={onHideTooltip}>
        <InboxMemberPopupMenu
          onClick={onHideTooltip}
          member={member}
          showRemoveConfirmation={showRemoveConfirmation}
        />
      </OutsideClickHandler>,
      {
        x: pxToRem(left) + 13.5,
        y: pxToRem(top + window.scrollY),
      },
      'right',
      20,
      {
        useDefaultStyle: false,
        onHideTooltip,
      },
    )
  }

  return (
    <>
      <InboxMemberRemoveConfirmation
        isOpen={isRemoveConfirmationOpen}
        member={member}
        campaignId={campaignId}
        onClose={hideRemoveConfirmation}
      />
      <Container pointer>
        <SideBarBlockItem
          key={member.email}
          text={member.name || member.email}
          noHighlight
          showNotification={false}
          onClick={toggleActive}
          active={isActive}
        />
      </Container>
    </>
  )
}

export default InboxMember
